import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=45b2c418&"
var script = {}
import style0 from "./staking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports